import { withStyles } from "@material-ui/core";
import * as React from "react";
import InputSearch, { IInputSearchProps } from "./InputSearch";

const styles = () => ({
  label: {
    marginTop: 8,
  },
  inputSearch: {
    color: "#a4a4a4",
    outlineColor: "#a4a4a4",
    backgroundColor: "#272727",
    padding: "6px 22px 6px 30px",
    border: "1px solid #212121",
  },
  iconSearch: {
    fontSize: 16,
    top: 6,
    left: 7,
  },
  iconRemove: {
    fontSize: 18,
    top: 5,
    right: 7,
  },
});

const MenuInputSearch = ({
  classes,
  newClasses,
  ...props
}: IInputSearchProps) => {
  const { label, inputSearch, iconSearch, iconRemove } = classes;
  return (
    <InputSearch
      {...props}
      newClasses={{ label, inputSearch, iconSearch, iconRemove }}
    />
  );
};

export default withStyles(styles)(MenuInputSearch);



// WEBPACK FOOTER //
// ./src/common/components/fields/MenuInputSearch.tsx